import useLobbySocket from "./useLobbySocket";
import { usePlayer, useMasterRoomsObject, useFavouriteTablesArray } from "../data/useLobby";
import { useDispatch } from "react-redux";
import {
  handleFavToggleClick,
  setToastMessage,
} from "../../../Poker/redux/slices/gameTableSlice";
import { useClickedFavToggle } from "../data/useGameTable";
import { useEffect } from "react";
import { TOAST_INFO, TOAST_SUCCESS } from "../../../Poker/data/Constants";
import useActiveGame from "../data/useActiveGame";
import { showToast } from "@/Poker/utils/toastUtils";

function useGameStateData(isGame) {
  const tempTableId = useActiveGame();
  const clickedFavToggle = useClickedFavToggle?.(tempTableId);

  if (!isGame) return {};

  return {
    tempTableId,
    clickedFavToggle,
  };
}

export default function useAddGameToFavorite(props) {
  const { isGame, roomId } = props;

  const dispatch = useDispatch();

  const masterRoomsObject = useMasterRoomsObject();
  const favouriteTablesArray = useFavouriteTablesArray();
  const { sendSaveFavoriteRequest } = useLobbySocket();

  const { tempTableId, clickedFavToggle } = useGameStateData(isGame);

  const handleSaveFavoriteRequest = (roomId) => {
    const roomDetails = masterRoomsObject?.[roomId];
    let favoritesaveProtocol = {
      action: roomDetails?.isFavorite ? "remove" : "add",
      gameDefId: roomDetails?.roomId,
    };
    if (isGame) {
      if (!clickedFavToggle) {
        dispatch(
          handleFavToggleClick({ status: true, tempTableId: tempTableId })
        );
        sendSaveFavoriteRequest(favoritesaveProtocol);
      }
    } else {
      sendSaveFavoriteRequest(favoritesaveProtocol);
    }
    showToast(
      !roomDetails?.isFavorite ? TOAST_SUCCESS : TOAST_INFO,
      !roomDetails?.isFavorite
        ? "Marked as favourite"
        : "Unmarked from favourites"
    );
  };
  return {
    handleSaveFavoriteRequest,
  };
}
